import { differenceWith, isEqual, toPairs } from 'lodash'

export const diff = (obj1: object, obj2: object) => differenceWith(toPairs(obj2), toPairs(obj1), isEqual)
